import SearchModel from'./SearchModel';
class CompanyModel {
    id              = -1
    nameCompany           = ""
    activity          = ""
    orpo           = ""
    infoAuto        = ""
    
    searchModel = null;
}

export default CompanyModel